import "./Rating.css";
import { useEffect, useState } from "react";

export function Rating({ setRating, lang, isAuth }) {
	const [ratings, setRatings] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [playerName, setPlayerName] = useState(null);

	useEffect(() => {
		const fetchRatings = async () => {
			try {
				let res;
				console.log(isAuth);
				if (isAuth) {
					setPlayerName(player.getName());
					res = await lb.getLeaderboardEntries("rating", {
						quantityTop: 5,
						includeUser: true,
						quantityAround: 2,
					});
				} else {
					res = await lb.getLeaderboardEntries("rating", { quantityTop: 8 });
				}

				setRatings(res);
			} catch (err) {
				console.error("lb.getLeaderboardEntries");
				setError("Не удалось загрузить рейтинг");
			} finally {
				setLoading(false);
			}
		};

		fetchRatings();
	}, []);

	if (loading) return <div className="loading">Загрузка...</div>;
	if (error)
		return (
			<div className="error">
				<button className="close-button" onClick={() => setRating(false)}>
					&times;
				</button>
				{error}
			</div>
		);
	if (!ratings || !ratings.entries) return <div>Нет данных о рейтинге</div>;

	return (
		<div className="rating-container">
			<div className="rating-header">
				<h2>{ratings.leaderboard.title[lang] || "Рейтинг игроков"}</h2>
				<button className="close-button" onClick={() => setRating(false)}>
					&times;
				</button>
			</div>

			<div className="rating-list-container">
				<div className="rating-list">
					{ratings.entries.map((entry, index) => (
						<div
							key={entry.player.id}
							className={
								playerName === entry.player.publicName ? "rating-item rating-player" : "rating-item"
							}
						>
							<div className="rank-badge">{entry.rank}</div>
							<div className="player-info">
								<img
									src={entry.player.getAvatarSrc("small")}
									alt={entry.player.publicName}
									className="player-avatar"
									onError={(e) => {
										e.target.onerror = null;
										e.target.src = "https://via.placeholder.com/40";
									}}
								/>
								<span className="player-name">{entry.player.publicName}</span>
							</div>

							<div className="player-score">{entry.formattedScore}</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
